import * as React from "react";
import {
  CreateButton,
  DatagridConfigurable,
  DateField,
  DateInput,
  EditButton,
  FilterButton,
  ImageField,
  List,
  NumberField,
  NumberInput,
  SelectColumnsButton,
  TextField,
  TopToolbar,
  useLocaleState,
} from "react-admin";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const filters = [
  <NumberInput key={0} source="id" label="id" min={1} />,
  <NumberInput key={1} source="position" label="position" min={0} />,
  <DateInput key={2} source="createdAt#$gte" label="Start Created At" />,
  <DateInput key={3} source="createdAt#$lte" label="End Created At" />,
];

export const PartnersList = () => {
  const [locale] = useLocaleState();

  return (
    <List
      filters={filters}
      sort={{ field: "position", order: "ASC" }}
      actions={<ListActions />}
    >
      <DatagridConfigurable rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" />
        <ImageField source="file.path" label="Image" />
        <TextField source={`title.${locale}`} />
        <NumberField source="position" />
        <DateField source="createdAt" showTime locales="lv-LV" />
        <EditButton />
      </DatagridConfigurable>
    </List>
  );
};
